/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { CardFormFields } from "./CardFormFields";
import * as t from "io-ts";

/**
 * Form data needed to create a payment method input form
 */

// required attributes
const CreateSessionResponseR = t.interface({
  orderId: t.string,

  correlationId: t.string,

  paymentMethodData: CardFormFields
});

// optional attributes
const CreateSessionResponseO = t.partial({});

export const CreateSessionResponse = t.intersection(
  [CreateSessionResponseR, CreateSessionResponseO],
  "CreateSessionResponse"
);

export type CreateSessionResponse = t.TypeOf<typeof CreateSessionResponse>;
